import {Injectable} from '@angular/core';
import {Headers, Http} from '@angular/http';
import {Callback} from '../models/callback';
import 'rxjs/add/operator/toPromise';

@Injectable()
export class CallbackService {
  private headers = new Headers({'Content-Type': 'application/json'});

  constructor(private http: Http) {
  }

  private static handleError(error: any): Promise<any> {
    console.error('An error has occurred with the Callback api service', error);
    return Promise.reject(error.message || error);
  }

  submit(callback: Callback): Promise<Callback> {
    const callbackUrl = 'https://staging.gridhaus.com/api/callback/';
    return this.http
      .post(callbackUrl, JSON.stringify(callback), {
        headers: this.headers
      })
      .toPromise()
      .then(res => {
        return res.json().data as Callback;
      }).catch(CallbackService.handleError);
  }
}



// WEBPACK FOOTER //
// /opt/build/repo/src/app/services/callback.service.ts